import { containsIllegalChrs, illegalChrs, removeDotGpxFrom } from "./FileNameUtility";

/**
 * Validates a string that will be used as a GPX file name, with or without the ".gpx" ending
 */
 export default class GpxFileNameChecker {
    
    notValid = false
    
    reset() {
        this.notValid = false;
    }

    // this could be an array of 2 rules, but I need the side-effect of setting this.notValid 
    rules = [
        (v: string) => {
            if (null === v || 0 == removeDotGpxFrom(v).length)  { this.notValid = true; return "File name must not be blank" }
            if (containsIllegalChrs(v))                         { this.notValid = true; return "File name cannot contain any of these: " + illegalChrs }

            this.notValid = false;
            return true;
        },
    ]
}